<template>
  <div class="serviceExperiencePage">
    <img src="../assets/ServiceExperience/banner.jpg" alt="" class="banner">
    <div class="chineseTitle">服务理念</div>
    <div class="englishTitle">— SERVICE CONCEPT —</div>
    <img src="../assets/ServiceExperience/philosophy.png" alt="" class="philosophy">
    <div class="chineseTitle">两大服务模式</div>
    <div class="englishTitle">— TWO SERVICE PATTERNS —</div>
    <div class="modeList">
      <div class="modeItem">
        <img src="../assets/ServiceExperience/modeImg1.png" alt="">
        <div class="redText">智能化系统服务</div>
        <div class="blackText">智能快捷</div>
      </div>
      <div class="modeItem">
        <img src="../assets/ServiceExperience/modeImg2.png" alt="">
        <div class="redText">人工定制化服务</div>
        <div class="blackText">贴心周全</div>
      </div>
    </div>
    <div class="chineseTitle">有温度的管家式1对1专属服务</div>
    <div class="englishTitle">— PROFESSIONAL SERVICES —</div>
    <img src="../assets/ServiceExperience/serviceImg.png" alt="" class="serviceImg">
    <div class="chineseTitle">快速差旅服务</div>
    <div class="englishTitle">— EFFICIENT SERVICE —</div>
    <div class="travelBg">
      <div class="travelItem">
        <img src="../assets/ServiceExperience/travelIcon1.png" alt="">
        <div class="text1">60秒迅速响应客户需求</div>
        <div class="text2">您的时间最为宝贵</div>
      </div>
      <div class="travelItem">
        <img src="../assets/ServiceExperience/travelIcon2.png" alt="">
        <div class="text1">7*24*365不间断服务</div>
        <div class="text2">商旅顾问时刻在您身边</div>
      </div>
    </div>
    <div class="chineseTitle">贴心增值服务</div>
    <div class="englishTitle">— VALUE ADDED SERVICE —</div>
    <div class="addServiceList">
      <div class="addServiceItem">
        <img src="../assets/ServiceExperience/addService1.png" alt="">
        <div class="text">差旅安全保障服务</div>
      </div>
      <div class="addServiceItem">
        <img src="../assets/ServiceExperience/addService2.png" alt="">
        <div class="text">代办选座值机服务</div>
      </div>
      <div class="addServiceItem">
        <img src="../assets/ServiceExperience/addService3.png" alt="">
        <div class="text">会员卡积分管理</div>
      </div>
      <div class="addServiceItem">
        <img src="../assets/ServiceExperience/addService4.png" alt="">
        <div class="text">定期提供差旅报告</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ServiceExperience',
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  @import "../css/ServiceExperience.less";
</style>



// WEBPACK FOOTER //
// src/pages/ServiceExperience.vue